import { render } from "./list-brand.vue?vue&type=template&id=069c01c2&scoped=true"
import script from "./list-brand.vue?vue&type=script&lang=js"
export * from "./list-brand.vue?vue&type=script&lang=js"

import "./list-brand.vue?vue&type=style&index=0&id=069c01c2&scoped=true&lang=css"

import exportComponent from "/Users/dereklei/Documents/DotnetProjects/WorkProjects/OAuth.Server.OneId/OAuth.Server/Web/Saas.Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069c01c2"]])

export default __exports__